export default "__VITE_ASSET__C8V3AjoT__"